const initialState = { data: null, loading: true };

export const GetPurchaseOrderByIdReducer = (state = initialState, action) => {
  switch (action.type) {
    case "get_purchaseorder_byid":
      return { ...state, data: action.data, loading: false };
    default:
      return state;
  }
};
